// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { createPopUp } from "./WebApp.PopUp";
import { FormField } from "./WebSite.Form.Field";
import { ControlMode } from "./WebSite.Page.Component";

export class DropDown extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.options = new Array();

    if (this.mode === ControlMode.edit) {
      this.determineElements();
      this.recalculate();
      this.attachHandlers();
    }

    this.visibleOptions = this.options;
    this.focused = new HtmlClassSwitch(this.element, "Focus");
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit)
      this.input.addEventListener(event, handler);
  }

  attachHandlers() {
    this.button.addEventListener("click", (event) => { this.toggleForm(); });
    this.label.addEventListener("click", (event) => { this.toggleForm(); });

    this.search.addEventListener(
      "input",
      (event) => {
        this.filterOptions();

        if (!this.isOpen())
          this.open(false);
      }
    );

    this.search.addEventListener("keydown", (event) => { this.handleSearchKey(event); });
    this.search.addEventListener("focus", (event) => { this.focused.setStatus(true); });
    this.search.addEventListener("blur", (event) => { this.focused.setStatus(false); });

    for (const option of this.options) {
      option.element.addEventListener("click", this.createSelectOptionHandler(option));
      option.element.addEventListener("keydown", this.createOptionKeyHandler(option));
    }

    this.element.addEventListener("keydown", this.createKeyHandler());
    this.addValueChangedHandler(this.input);

    this.element.addEventListener(
      "blur",
      (event) => {
        if (!this.popup.isOpen() && event.relatedTarget !== this.button && event.relatedTarget !== null)
          this.validate();
      }
    );
  }

  close() {
    this.search.value = "";
    this.filterOptions();
    this.popup.close();

    if (!this.element.contains(document.activeElement))
      this.validate();
  }

  createKeyHandler() {
    return (event) => {
      return this.handleKey(event);
    }
  }

  createOptionKeyHandler(option) {
    return (event) => {
      return this.handleOptionKey(option, event);
    }
  }

  createSelectOptionHandler(option) {
    return (event) => {
      this.select(option);
      this.close();
      this.focus();

      return true;
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.dropDown = query.getChild(WithClass("Options"));
    this.popup = createPopUp(this.dropDown, this.element, true, this.element, 0, this.element);

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.tabIndex = -1;

    this.label = query.getChild(WithClass("Label"));

    const inputs = query.getChildren(WithTagName("INPUT"));

    this.search = inputs[0];
    this.input = inputs[1];

    const options = new DomQuery(this.dropDown).getChildren(WithClass("Option"));

    for (const option of options)
      this.options.push(new DropDownOption(option));
  }

  filterOptions() {
    const query = this.search.value.toLowerCase();
    this.visibleOptions = new Array();

    for (const option of this.options) {
      const text = option.element.textContent.toLowerCase();

      if (text.includes(query)) {
        this.visibleOptions.push(option);
        option.show();
      }
      else
        option.hide();
    }
  }

  focus() {
    this.search.focus();
  }

  focusNext(option) {
    const index = this.visibleOptions.indexOf(option);

    if (index !== -1 && index < this.visibleOptions.length - 1)
      this.visibleOptions[index + 1].focus();
  }

  focusPrevious(option) {
    const index = this.visibleOptions.indexOf(option);

    if (index > 0)
      this.visibleOptions[index - 1].focus();
  }

  getValue() {
    if (this.mode === ControlMode.edit)
      return this.input.value !== "" ? this.input.value : null;
    else if (this.mode === ControlMode.display)
      return this.element.dataset.Value;
    else
      throw "Unknown control mode: " + this.mode;
  }

  handleKey(event) {
    if (event.ctrlKey && event.code === "Space") {
      this.toggleForm();
      event.stopPropagation();
    }
  }

  handleOptionKey(option, event) {
    if (event.code === "Space" || event.code === "Enter") {
      this.select(option);
      this.close();
      this.focus();

      event.preventDefault();
    }
    else if (event.code === "Escape") {
      this.close();
      this.focus();

      event.stopPropagation();
    }
    else if (event.code === "ArrowUp") {
      this.focusPrevious(option);
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowDown") {
      this.focusNext(option);
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "Home") {
      this.visibleOptions[0].focus();
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "End") {
      this.visibleOptions[this.visibleOptions.length - 1].focus();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  handleSearchKey(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      event.stopPropagation();

      if (this.visibleOptions.length > 0)
        this.visibleOptions[0].element.focus();
    }
  }

  isOpen() {
    return this.popup.isOpen();
  }

  open(focus) {
    if (focus) {
      this.search.value = "";
      this.filterOptions();
    }

    this.popup.open();

    const selected = this.visibleOptions.find(element => element.selected);

    if (focus) {
      if (selected !== undefined)
        selected.focus();
      else if (this.visibleOptions.length > 0)
        this.visibleOptions[0].focus();
    }
  }

  recalculate() {
    this.label.innerHTML = "";

    for (const option of this.options) {
      if (option.value === this.input.value) {
        option.selected = true;
        this.label.innerHTML = option.element.innerHTML;
      }
      else
        option.selected = false;
    }
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      this.input.value = fieldValue;
      this.recalculate();

      this.input.dispatchEvent(new Event("change"));
    }
  }

  select(option) {
    if (!this.input.disabled && !option.selected)
      this.setValue(option.value);
  }

  toggleForm() {
    if (!this.input.disabled) {
      if (this.isOpen())
        this.close();
      else
        this.open(true);
    }
  }
}

class DropDownOption {
  constructor(element) {
    this.element = element;
    this.element.tabIndex = -1;

    this.classSwitch = new HtmlClassSwitch(this.element, "Selected");
    this.hiddenSwitch = new HtmlClassSwitch(this.element, "Hidden");
  }

  focus() {
    this.element.focus();
  }

  hide() {
    this.hiddenSwitch.setStatus(true);
  }

  show() {
    this.hiddenSwitch.setStatus(false);
  }

  get selected() {
    return this.classSwitch.getStatus();
  }

  set selected(selected) {
    this.classSwitch.setStatus(selected);
    this.element.setAttribute("aria-selected", selected);
  }

  get value() {
    return this.element.dataset.Value;
  }
}

interactivityRegistration.register("DropDown", function (element) { return new DropDown(element); });
